module.exports = __webpack_public_path__ + "media/images/front/dr_hayashi_t-78adc6f34122436b7ec5db4dcd41d3f2.jpg";